export default {
	computed: {
		currentUser() {
			return this.$store.state.user?.user;
		},
		currentUserId() {
			return this.currentUser?.id || this.currentUser?._id;
		},
		isSuperAdmin() {
			return this.currentUser?.adminRole === 'superadmin';
		},
		canManageSettings() {
			return this.isSuperAdmin || this.$p >= 40;
		},
		canToggleStatus() {
			return this.isSuperAdmin || this.$p >= 40;
		},
		canCreate() {
			return this.isSuperAdmin || this.$p >= 20;
		},
	},
	methods: {
		isCreator(item) {
			if (!item?.createdBy) return false;
			if (this.isSuperAdmin || this.$p >= 40) return true;

			const createdById = typeof item.createdBy === 'object'
				? (item.createdBy.id || item.createdBy._id)
				: item.createdBy;
			return createdById === this.currentUserId;
		},
		canEditOrDelete(item) {
			if (!item) return this.canCreate;
			return this.isSuperAdmin || this.$p >= 40 || (this.$p >= 20 && this.isCreator(item));
		},
	}
};
